import { useEffect, useState } from 'react'

// Seconds left until `expiresAt`, by the SERVER's clock: the offset between
// the server's time when the attempt was loaded and the browser's is kept, so
// a phone with the wrong time still counts down correctly. null = untimed.
export function useCountdown(expiresAt: string | null, serverNow: string): number | null {
  const [offset] = useState(() => Date.parse(serverNow) - Date.now())
  const compute = () => (expiresAt === null ? null : Math.max(0, Math.ceil((Date.parse(expiresAt) - (Date.now() + offset)) / 1000)))
  const [left, setLeft] = useState(compute)
  useEffect(() => {
    if (expiresAt === null) return
    setLeft(compute())
    const timer = setInterval(() => setLeft(compute()), 1000)
    return () => clearInterval(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiresAt])
  return left
}

const two = (n: number) => String(n).padStart(2, '0')

export function clockText(seconds: number): string {
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = seconds % 60
  return h > 0 ? `${h}:${two(m)}:${two(s)}` : `${two(m)}:${two(s)}`
}
